import React from 'react'
import {
  Button,
  Tooltip,
  Theme,
  ClickAwayListener,
  useMediaQuery,
} from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import clsx from 'clsx'
import LinkStyleButton from '../LinkStyleButton'

const useStyles = makeStyles((theme: Theme) => ({
  buttonRoot: {
    minWidth: 0,
    padding: 0,
    maxHeight: '26px',
  },
  arrow: {
    '&:before': {
      boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.2)',
    },
    color: theme.palette.common.white,
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(12),
    padding: theme.spacing(4),
    boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.16)',
    whitespace: 'nowrap',
  },
  tooltipMobile: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(12),
    padding: theme.spacing(4),
    boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.16)',
    whitespace: 'nowrap',
    top: theme.spacing(2),
  },
}))

interface AddToDocsButtonProps {
  isLinkStyleButton?: boolean
  children: JSX.Element
  handleClick?: () => void
  toolTipText: JSX.Element
  placement?: 'top' | 'bottom' | 'left' | 'right'
  leaveDelay?: number
  classNameTooltip?: string
  showOutline?: boolean
}

const TooltipButton: React.FC<AddToDocsButtonProps> = ({
  isLinkStyleButton = false,
  children,
  handleClick,
  toolTipText,
  placement = 'top',
  leaveDelay = 2500,
  classNameTooltip,
  showOutline = true,
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm')) === true
  const [open, setOpen] = React.useState<boolean>(false)

  return (
    <>
      {isLinkStyleButton && (
        <LinkStyleButton onClick={handleClick}>{children}</LinkStyleButton>
      )}

      {isDesktop && !isLinkStyleButton && (
        <Tooltip
          arrow
          interactive
          title={toolTipText}
          placement={placement}
          classes={{
            arrow: classes.arrow,
            tooltip: clsx(classes.tooltip, classNameTooltip),
          }}
          leaveDelay={leaveDelay}
        >
          <Button
            variant={showOutline ? 'outlined' : 'text'}
            onClick={() => {
              if (typeof handleClick === 'function') handleClick()
            }}
            classes={{
              root: classes.buttonRoot,
            }}
          >
            {children}
          </Button>
        </Tooltip>
      )}

      {!isDesktop && !isLinkStyleButton && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <span>
            <Tooltip
              title={toolTipText}
              placement="top"
              classes={{
                arrow: classes.arrow,
                tooltip: clsx(classes.tooltipMobile, classNameTooltip),
              }}
              onClose={() => setOpen(false)}
              open={open}
              arrow
              interactive
              disableFocusListener
              leaveDelay={leaveDelay}
            >
              <Button
                variant={showOutline ? 'outlined' : 'text'}
                onClick={() => {
                  setOpen(true)
                  if (typeof handleClick === 'function') handleClick()
                }}
                classes={{
                  root: classes.buttonRoot,
                }}
              >
                {children}
              </Button>
            </Tooltip>
          </span>
        </ClickAwayListener>
      )}
    </>
  )
}

export default TooltipButton
